import fileUpload from 'public/js/includes/modules/FileUpload';

// 5 MB
fileUpload.maxFileSize = 5242880;
fileUpload.bindEventListeners();
